import Enum from '@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '@/modules/core/app/helpers/store';

export class FlinksType extends Enum {
  key!: string;

  value!: string;

  description!: string;

  static BANKING: FlinksType = {
    key: 'banking',
    get value(): string {
      return Lang.t('financialaccount.banking-accounts');
    },
    get description(): string {
      const checkingAccountLabel: string = getters.auth.getCurrentEstate()?.jurisdiction.isInCanada
        ? Lang.t('asset.chequing')
        : Lang.t('asset.checking');
      return Lang.t('financialaccount.checking-savings-mortgage', {
        checking: checkingAccountLabel
      });
    }
  };

  static INVESTMENT: FlinksType = {
    key: 'investment',
    get value() {
      return Lang.t('financialaccount.investment-accounts');
    },
    get description() {
      if (getters.auth?.getUser()?.permission?.canAccessFlinksInvestment === false) {
        return Lang.t('financialaccount.investment-not-available');
      }
      return Lang.t('financialaccount.brokerage-accounts-and');
    }
  };
}
